/**
 * Finance tab originals badge (FE-005B).
 * Field of truth: application.originalsReceivedAt — same signal as CP CLIENT_RECEIVED.
 * Does not infer send/dispatch. Does not compute workflowState.
 */

export type OriginalsFinanceStage = 'PENDING' | 'RECEIVED';

export const ORIGINALS_FINANCE_STAGE_META: Record<
  OriginalsFinanceStage,
  { label: string; color: string }
> = {
  PENDING: { label: 'Не получены', color: 'default' },
  RECEIVED: { label: 'Получены клиентом', color: 'green' },
};

export function resolveOriginalsFinanceStage(
  originalsReceivedAt: string | Date | null | undefined
): OriginalsFinanceStage {
  if (originalsReceivedAt == null) return 'PENDING';
  const raw = String(originalsReceivedAt).trim();
  return raw ? 'RECEIVED' : 'PENDING';
}

export function originalsFinanceStageMeta(
  originalsReceivedAt: string | Date | null | undefined
): { stage: OriginalsFinanceStage; label: string; color: string } {
  const stage = resolveOriginalsFinanceStage(originalsReceivedAt);
  return { stage, ...ORIGINALS_FINANCE_STAGE_META[stage] };
}
